import React from 'react';
import PropTypes from 'prop-types';

const NbcAlertBar = ({ model }) => {
    return (
        <div className="nbc-alert-bar">
            <div className="container">
                <div
                    className="nbc-alert-bar__richtext"
                    dangerouslySetInnerHTML={{ __html: model.text }}
                >
                </div>
            </div>
        </div>
    );
};

NbcAlertBar.propTypes = {
    model: PropTypes.shape({
        text: PropTypes.string,
    })
};

export default NbcAlertBar;
